module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-body"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.profileAddress.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "save": _vm.save,
      "translation": "form.profileAddress",
      "hasLabel": true,
      "labelWidth": "150px"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f6d949e","hasScoped":false}!./src/app/pages/withNavigation/profile/address/address.html
// module id = 3058
// module chunks = 1